import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse } from "@/lib/types";

export type NotificationInboxItem = {
  body: {
    details: Array<{
      label: string;
      value: string;
    }>;
    preview: string | null;
  };
  dateCreated: string;
  destination: {
    matterId: string;
    object: {
      id: string;
      type: string;
      contactId?: string | null;
    } | null;
    pageId: string;
  } | null;
  domainEventId: string;
  eventType: string;
  id: string;
  priority: "low" | "high";
  readAt: string | null;
  title: string;
};

export type NotificationInboxFilters = {
  unread?: boolean;
  tasks?: boolean;
  notes?: boolean;
  texts?: boolean;
};

export type NotificationInboxPage = {
  notifications: NotificationInboxItem[];
  unreadCount: number;
  unreadCounts: {
    standard: number;
    communication: number;
  };
};

export type NotificationInboxParams = NotificationInboxFilters & {
  cursor?: string;
};

export const getNotificationInboxItems = (
  params: NotificationInboxParams = {},
  signal?: AbortSignal,
) => {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<NotificationInboxPage>>("matters/v6/notifications", {
      params,
      signal,
    })
    .then((res) => res.data);
};

export const updateNotificationInboxItemsReadState = ({
  notificationIds,
  read,
}: {
  notificationIds: string[];
  read: boolean;
}) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<Array<Pick<NotificationInboxItem, "id" | "readAt">>>>(
      "matters/v6/notifications",
      {
        notificationIds,
        read,
      },
    )
    .then((res) => res.data);
};

export const updateNotificationInboxReadState = ({
  id,
  read,
}: {
  id: string;
  read: boolean;
  silent?: boolean;
}) => updateNotificationInboxItemsReadState({ notificationIds: [id], read });

export const deleteNotificationInboxItem = (id: string) =>
  authenticatedFastApiAxiosInstance
    .delete<APIResponse<{ id: string }>>(`matters/v3/notifications/${id}`)
    .then((res) => res.data);
